import { mapDeep } from '../utils/immutableTreeHelpers'

export default function inheritVisibility(navigation) {
  return mapDeep(navigation, (n, parent) =>
    parent && parent.get('isVisible') === false ? n.set('isVisible', false) : n,
  )
}
